import * as React from "react";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import LeadStatus from "../../../model/lead/LeadStatus";
import MultiSelectList from "../../../hiberUiKit/src/molecules/MultiSelectList/MultiSelectList";
import {WorkspaceFilterReduxProps} from "./WorkspaceFilter";
import MultiSelectWorkspaceFilter from "./MultiSelectWorkspaceFilter";

class LeadStatusFilter extends MultiSelectWorkspaceFilter<LeadStatus> {
	renderContent(items: LeadStatus[]): JSX.Element {
		return (
			<div className={"c-filter-status-input-container"}>
				<MultiSelectList items={items}
								 itemToId={(item: LeadStatus) => item.id}
								 itemToLabel={(item: LeadStatus) => item.label}
								 selectedItemIds={this.getSelectedItems().map(s => s.id)}
								 onUpdate={this.onChange}
								 updateOnChange
								 componentBetweenInputAndList={this.getNegationCheckbox()}/>
			</div>
		)
	}

	itemToId(item: LeadStatus): string {
		return item.id;
	}

	itemToLabel(item: LeadStatus): string {
		return item.getStatusLabel()
	}
}


function mapStateToProps(state: RootState) {
	return {
		items: state.leadStatus.leadStatuses
	}
}

export default connect<WorkspaceFilterReduxProps<LeadStatus>>(mapStateToProps)(LeadStatusFilter)